import { ModelVehicleModel } from '@app/src/views/StepOne/form/models/modelVehicle';
import { ModelVehicleDTO } from '@app/src/views/StepOne/form/dtos';

export const hydrateData = (data: ModelVehicleDTO[]) => data.map((item) => ({
  name: item.name,
  brandId: item.brand_id,
  state: item.state,
  adecsysId: item.adecsys_id,
  id: item.id,
  vehicleTypeId: item.vehicle_type_id
})) as ModelVehicleModel[];
